import type { CustomStatisticMethod, TypeInstanceMap } from '@lighthouse/core'

export const CUSTOM_STATISTIC_METHOD_OPTIONS: {
    label: string
    value: CustomStatisticMethod
    innerTypeList: TypeInstanceMap[]
}[] = [
    { label: '计数', value: 'COUNT', innerTypeList: ['TEXT', 'ARRAY', 'NUMBER', 'DATE', 'BOOL', 'RICH_TEXT', 'NULL', 'RUNTIME'] },
    { label: '去重计数', value: 'COUNT_UNIQUE', innerTypeList: ['TEXT', 'ARRAY', 'NUMBER', 'DATE', 'BOOL'] },
    { label: '求和', value: 'SUM', innerTypeList: ['NUMBER'] },
    { label: '最大值', value: 'MAX', innerTypeList: ['NUMBER'] },
    { label: '最小值', value: 'MIN', innerTypeList: ['NUMBER'] },
    { label: '平均值', value: 'AVG', innerTypeList: ['NUMBER'] }
]
